<template>
  <div class="sort-setting btnHover">
    <el-dropdown trigger="click" :hide-on-click="false" placement="bottom" @visible-change="visibleChange">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_sort_settings"></i>
        排序设置 {{headNumber && isOpen ? headNumber : ''}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown sort-setting-dropdown">
        <div class="reset" v-if="selectData.length > 0">
          <span class="title">排序设置</span>
          <div class="switch">
            <span style="margin-right: 8px;">{{isOpen ? '已生效' : '已停用'}}</span>
            <el-switch v-model="isOpen" @change="switchChange"></el-switch>
          </div>
        </div>
        <vuedraggable class="content" handle=".drag" element="div" v-bind="dragOptions" @update="end" @add="end" :list="selectData" v-if="selectData.length > 0">
          <div class="item" v-for="(item, index) in selectData" :key="item.key">
            <span class="drag"><i class="icon iconfont iconicon_drag_order tableIconHover"></i></span>
            <el-select v-model="item.level1" placeholder="请选择" :popper-append-to-body="false" value-key="value" popper-class="sort-setting-select" @change="selectChange(item)">
              <el-option
                v-for="temp in listFilter"
                :key="temp.value"
                :label="temp.label"
                :disabled="temp.hide"
                :value="temp">
              </el-option>
            </el-select>
            <el-select v-model="item.level2" placeholder="请选择" :popper-append-to-body="false" :disabled="!item.level1" @change="dataChange" popper-class="sort-setting-select-2">
              <el-option
                v-for="temp in item.level1.children"
                :key="temp.value"
                :label="temp.label"
                :value="temp">
              </el-option>
            </el-select>
            <span class="tableIconHover" @click="deleteItem(index)"><i class="icon iconfont iconicon_close1"></i></span>
          </div>
        </vuedraggable>

        <div class="add" v-if="selectData.length < list.length">
          <span class="text-blue" @click="addItem">
            <i class="icon iconfont iconicon_new_subproject"></i>
            添加排序条件
          </span>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import { mapActions, mapMutations, mapState } from 'vuex'
import bus from '@/bus'
export default {
  props: ['dataset', 'sorting_rules', 'sort_switch'],
  components: {
    vuedraggable
  },
  data() {
    return {
      isOpen: false,
      list: [],
      selectData: [],
      dragOptions: {
        animation: 200,
        group: 'list',
      },
      isChange: false
    }
  },
  created() {
    bus.$on('closeSortSwitch', () => {
      this.isChange = true
      this.isOpen = false
      this.visibleChange(false)
    })
  },
  destroyed() {
    bus.$off('closeSortSwitch')
  },
  computed: {
    ...mapState('customKey/customKey', {
      sort: state => state.sort,
      count: state => state.count
    }),
    listFilter() {
      return this.list.map(temp => {
        console.log(temp, this.selectData)
        temp.hide = Boolean(this.selectData.find(res => res.level1.value === temp.value))
        return temp
      })
    },
    headNumber() {
      return this.selectData.reduce((pre, res) => pre + (res.level2 ? 1 : 0), 0)
    }
  },
  watch: {
    dataset: {
      handler() {
        let arr = JSON.parse(JSON.stringify(this.dataset))
        this.list = arr.map(res => {
          res.children = this[res.children]
          return res
        })
        this.initChange()
        this.isOpen = Boolean(this.sort_switch)
      },
      deep: true,
      immediate: true
    },
    sorting_rules: {
      handler() {
        this.$nextTick(() => {
          this.initChange()
        })
      },
      deep: true
    }
  },
  methods: {
    initChange() {
      this.selectData = []
      if(this.sorting_rules) {
        let arr = this.sorting_rules.map(res => {
          let key = Object.keys(res)[0]
          const level1 = this.list.find(data => data.label === key)
          if (!level1) {
            return null
          }
          let obj = {
            key: this.uuid(),
            level1
          }

          if (level1.children) {
            obj.level2 =  obj.level1.children.find(temp => temp.value === res[key])
          }
          return obj
        })
        this.selectData = arr.filter(item => item !== null)
      }
    },
    addItem() {
      if (this.selectData && this.selectData.length === 0) {
        let levelList = this.listFilter.find(res => res.label === '优先级')
        let sort = this.sort.find(res => res.value === 'desc')
        this.selectData.push({ key: this.uuid(), level1: levelList, level2: sort})
        this.isOpen = true
        this.isChange = true
      } else {
        this.selectData.push({ key: this.uuid(), level1: '', level2: '' })
      }
    },
    async end() {
      this.isChange = true
    },
    deleteItem(idx) {
      this.isChange = true
      this.selectData.splice(idx, 1)
    },
    dataChange() {
      this.isOpen = true
      this.isChange = true
    },
    switchChange() {
      this.isChange = true
    },
    visibleChange(val) {
      if(val) {
        this.isChange = false
      }
      if(!val && this.isChange) {
        let arr = this.selectData.map((res) => {
          return {
            [res.level1.label]: res.level2.value
          }
        })
        this.$emit('change', { sorting_rules: arr, sort_switch: Number(this.isOpen) })
      }
    },
    selectChange(val) {
      this.isChange = true
      val.level2 = ''
    }
  }
}
</script>
<style lang="scss">
.sort-setting-select-2 {
  width: 171px !important;
}
.sort-setting-select {
  .is-disabled {
    color: #BFBFBF;
    &:hover {
      background-color: initial;
    }
  }
}
.sort-setting-dropdown {
  width: 380px;
  max-height: inherit;
  overflow: visible;
  padding-bottom: 0;
  padding-top: 0;
  .add {
    height: 48px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(32, 32, 32, 0.8);
    i {
      margin-right: 9px;
      font-size: 14px !important;
    }
  }
  .reset {
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    flex-shrink: 0;
    margin-top: 0;
  }
  .content {
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    padding-bottom: 12px;
    .item{
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 7px;
      height: 48px;
      .el-select {
        width: 134px;
      }
      &>span i {
        font-size: 14px !important;
        color: rgba(32, 32, 32, 0.4);
      }
    }
  }
}
.sort-setting {
  margin-left: 8px;
}
</style>
